import { useState, useEffect } from 'react';
/**
 * Returns true if the current window size is within the provided breakpoint. Defaults to
 * the standard mobile breakpoint if none is provided.
 * @param breakpoint
 */
export function useBreakpoint(breakpoint = '984px') {
    const [hitBreakpoint, setHitBreakpoint] = useState(window.matchMedia(`(max-width: ${breakpoint})`).matches);
    useEffect(() => {
        const mediaQuery = window.matchMedia(`(max-width: ${breakpoint})`);
        const handler = function () {
            setHitBreakpoint(this.matches);
        };
        mediaQuery.addEventListener("change", handler);
        return () => mediaQuery.removeEventListener("change", handler);
    }, []);
    return hitBreakpoint;
}
